<!--
 * @Author: owen
 * @Date: 2022-04-09 18:08:23
 * @LastEditors: owen
 * @LastEditTime: 2022-04-24 14:35:28
 * @FilePath: \app-pcweb\src\views\hUser\vip.vue
-->
<template>
  <div class="experienceWallet">
    <div class="lh16" v-if="this.surplusTime > 0">
      <span>{{ $t('Datalang.home_about_decay') }}</span>&nbsp;
      <span class="txtColor1">{{ experienceObj.experienceDecayRatio }}%</span>&nbsp;&nbsp;&nbsp;
      <span class="txtColor2">{{ surplusTxt }}</span>
    </div>
    <div class="goDiv" v-if="!isFreeMode()">
      <span class="txtColor3">{{ $t('Datalang.home_convert_real') }}</span>
      <el-button class="btn1" size="small" @click.stop="PopupWindowShow = true">GO</el-button>
    </div>
    <PopupDialog
      ref="PopupDialog"
      width="500px"
      :dataOpt="{ title: $t('Datalang.Recharge_TIP_tip') }"
      :show.sync="PopupWindowShow"
      @close="PopupWindowShow = false"
    >
      <template #center>
        <div class="modal-info">
          <p>{{ formatLang($t("Datalang.home_bonus_funds"), [' ' + divideAccuracy(experienceObj.maxRate, 2)]) }}%</p>
          <div align="center">
            <el-button class="tip-btn" type="primary" @click="clickFun">{{ $t("Datalang.HomePage_BTM_gorecharge") }}</el-button>
          </div>
        </div>
      </template>
    </PopupDialog>
  </div>
</template>

<script>
import experienceWallet from "@/lobby_common/mixins_components/experienceWallet/index.js";
import PopupDialog from "@/components/PopupDialog";
export default {
  components: {
    PopupDialog
  },
  props: [],
  mixins: [experienceWallet],
  data() {
    return {};
  },
  filters: {},
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.experienceWallet {
  font-size: 14px;
  @media (max-width: 768px) {
    font-size: 12px;
  }
  .lh16{
    line-height: 16px;
  }
  .txtColor1{
    color: var(--font-color-1800);
  }
  .txtColor2{
    color: var(--font-color-1000);
  }
  .txtColor3{
    color: var(--font-color-1600);
    margin-right: 5px;
  }
  .goDiv{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 5px;
    .btn1 {
      @include buttonPrimary;
    }
  }
}
.modal-info{
  .tip-btn{
    margin-top: 10px;
    @include buttonPrimary;
  }
}
</style>
